import React, { Component, PropTypes } from 'react';
import './Jolteon.scss';

class Jolteon extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="jolteon">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Jolteon;



/** WEBPACK FOOTER **
 ** ./source/135-jolteon/Jolteon.js
 **/